import { render, staticRenderFns } from "./complianceEvalTableDetail.vue?vue&type=template&id=06187ab6"
import script from "./complianceEvalTableDetail.vue?vue&type=script&lang=js"
export * from "./complianceEvalTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06187ab6')) {
      api.createRecord('06187ab6', component.options)
    } else {
      api.reload('06187ab6', component.options)
    }
    module.hot.accept("./complianceEvalTableDetail.vue?vue&type=template&id=06187ab6", function () {
      api.rerender('06187ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/evalTable/complianceEvalTableDetail.vue"
export default component.exports